export const youtubeVideoRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/

export function isYoutubeUrl(url) {
  return url && youtubeVideoRegex.test(url)
}

export function getYoutubeVideoID(url) {
  let match = url.match(youtubeVideoRegex)
  return match && match[5].length === 11 ? match[5] : null
}
